import { handleGlobalErrors } from '../errors/use-error-handler'

handleGlobalErrors()
